"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameModule = void 0;
const Alignment_1 = require("../../enums/Alignment");
const GameCenterModuleStatusType_1 = require("../../enums/game-center/GameCenterModuleStatusType");
exports.gameModule = {
    order: 1,
    name: 'NEW GAME MODULE',
    headerTitle: 'GAMES',
    headerTitleStyle: {
        font: 'bebas',
        color: 'FFFFFF',
        fontSize: '24px',
        textAlign: Alignment_1.Alignment.LEFT,
    },
    descriptionText: 'Play our games and compete for rewards',
    descriptionStyle: {
        font: 'bebas',
        color: 'FFFFFF',
        fontSize: '16px',
        textAlign: Alignment_1.Alignment.LEFT,
    },
    games: [],
    status: GameCenterModuleStatusType_1.GameCenterModuleStatusType.ACTIVE,
    startDate: null,
    endDate: null,
};
